<template>
  <component :is="type" class="card"><slot /></component>
</template>

<script>
/**
 * Card is used to visually separate sections on a page content area.
 * Use only Bootstrap utility classes ie. (padding, margin) to style overrides
 */
export default {
  name: "Card",
  status: "ready",
  release: "1.0.0",
  props: {
    /**
     * The html element name used for the card.
     */
    type: {
      type: String,
      default: "div",
    },
  },
};
</script>

<style lang="scss">
@import "../../design-system/assets/tokens/tokens";
.card {
  @include reset;
  border-radius: $radius-card;
  padding: $space-s $space-s;
  background: #fff;
  box-shadow: $shadow-l;
  @media (min-width-for("md")) {
    padding: $space-m;
  }
  @media (min-width-for("lg")) {
    padding: $space-l;
  }
}
</style>
